import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiFetch from "../../utils/apiFetch";

const CourseReaderPage = () => {

  const { systemId, sectionId, lessonId } = useParams();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadItems();
  }, []);

  async function loadItems() {
    try {
      const data = await apiFetch(
        `/api/systems/${systemId}/sections/${sectionId}/lessons/${lessonId}/items`
      );
      setItems(data.items || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <div style={{ padding: 40 }}>Cargando...</div>;

  return (
    <div style={{ padding: 40, maxWidth: 800, margin: "0 auto" }}>

      {items.length === 0 ? (
        <p>No hay contenido aún.</p>
      ) : (
        items.map((item) => (

          <div key={item.id} style={{ marginBottom: 30 }}>

            <h3>{item.title}</h3>

            {/* TEXTO */}
            {item.type === "text" && (
              <div style={{ whiteSpace: "pre-line" }}>
                {item.content}
              </div>
            )}

            {/* AUDIO */}
            {item.type === "audio" && (
              <div>
                <div style={{ whiteSpace: "pre-line" }}>
                  {item.content}
                </div>

                {item.media_url && (
                  <audio controls style={{ width: "100%", marginTop: 10 }}>
                    <source src={item.media_url} type="audio/mpeg" />
                  </audio>
                )}
              </div>
            )}

            {/* VIDEO */}
            {item.type === "video" && item.media_url && (
              <div style={{ marginTop: 10 }}>
                <iframe
                  width="100%"
                  height="315"
                  src={item.media_url}
                  title="Video"
                  frameBorder="0"
                  allowFullScreen
                />
              </div>
            )}

            {/* DESCARGA */}
            {item.type === "download" && item.media_url && (
              <a
                href={item.media_url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  marginTop: 10,
                  padding: "10px 14px",
                  background: "#0a2230",
                  color: "#fff",
                  borderRadius: 8,
                  textDecoration: "none",
                  fontWeight: 600
                }}
              >
                Descargar recurso
              </a>
            )}

          </div>

        ))
      )}

    </div>
  );
};

export default CourseReaderPage;